var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnowboarding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "a",
    points: "0 28.466 7.587 29.096 31.888 50 23.136 49.157"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "b",
    points: "3.794 28.781 7.587 29.096 31.888 50 27.512 49.578"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    opacity: 0.301
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m29.582 25.898.237.114.374 1.257-.159.538-.452-1.909Zm-24.402-2.84.797.03.19 1.442-.986-.824-.001-.647Zm35.617-17.641-1.459 2.377 2.642 1.202-3.447 1.293-8.951 4.269 1.916 8.34-.375 1.256-5.681-2.726-7.32-3.217-.988-2.685-1.723.695-5.998 6.677-1.062 1.041-.4-3.018-1.966-.074 5.164-6.849 2.47-2.722 3.4-1.605 3.735 2.037 5.922-1.472.357-2.539 2.331.854 9.694-2.907 1.739-.227Zm1.955 1.095 1.117.57-.775-.038-.52-.237.178-.295Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m29.583 25.898.236.114.375 1.258-.16.537-.451-1.909Zm9.76-18.11 2.636 1.208-3.446 1.293-8.951 4.269 1.916 8.34-.375 1.256-2.166-1.042-1.647-10.33 12.032-4.994Zm4.064-1.688 2.719 1.092-3.032-.148-.52-.237.294-.483.54-.224Z",
    opacity: 0.299
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EBC1A7",
    points: "17.655 5.254 24.793 5.252 24.792 7.939 21.346 9.328 17.654 7.94",
    transform: "rotate(8 21.223 7.29)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "17.784 1.91 21.739 .526 25.694 1.908 25.693 5.623 17.783 5.624",
    transform: "rotate(8 21.739 3.075)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "17.327 5.592 25.237 5.591 24.903 6.882 17.532 7.051",
    transform: "rotate(8 21.282 6.321)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "1.412 24.633 2.439 22.959 5.977 23.088 6.241 25.082 1.933 24.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "42.573 6.807 43.6 5.133 47.138 5.262 47.402 7.256 43.094 7.044"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "17.787 20.509 24.539 23.476 29.819 26.012 30.747 29.121 29.273 30.372 27.822 37.838 25.668 41.228 22.128 38.497 21.547 36.023 23.077 28.263 18.365 26.012 17.515 28.668 16.409 30.768 13.542 31.04 11.395 28.263 14.152 22.354"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "28.238 25.252 29.819 26.012 30.747 29.121 29.273 30.372 27.822 37.838 25.668 41.228",
    opacity: 0.299
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowboarding);
export default __webpack_public_path__ + "static/media/snowboarding.70946def1f81ee83290902c4fd28973e.svg";
export { ForwardRef as ReactComponent };